/**
 * Hostname of a URL string, or '' when the value is not a valid absolute URL.
 * @param {string} urlString
 * @returns {string}
 */
function hostnameOf(urlString) {
  try {
    return new URL(urlString).hostname;
  } catch {
    return '';
  }
}

function stripTrailingSlash(url) {
  return url.replace(/\/$/, '');
}

/**
 * True when the page is served from a local browser origin.
 * @param {string} hostname
 * @returns {boolean}
 */
export function isLocalHostname(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

/**
 * Resolve the Express API origin.
 *
 * When the UI runs on localhost, always target the local API (default
 * http://localhost:5001). Production CORS does not allow localhost origins,
 * so a client/.env that still has REACT_APP_API_URL=https://learn.storykin.app
 * would otherwise fail admin fetches with a CORS preflight error.
 *
 * @param {{ envUrl?: string, hostname?: string }} [options]
 * @returns {string}
 */
export function resolveApiBaseUrl({
  envUrl = process.env.REACT_APP_API_URL,
  hostname = typeof window !== 'undefined' ? window.location.hostname : ''
} = {}) {
  if (isLocalHostname(hostname)) {
    if (envUrl && isLocalHostname(hostnameOf(envUrl))) {
      return stripTrailingSlash(envUrl);
    }
    return 'http://localhost:5001';
  }

  return stripTrailingSlash(envUrl || 'http://localhost:5001');
}
